import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { CsrfTokenService } from '../security/csrf.service';
import { AuthService } from '../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { getApiBaseUrl } from '../constants/api-endpoints';
import { AUTH_SESSION_HEADER } from '../auth/auth-session';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private injector: Injector,
    private authService: AuthService
  ) {} 

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const translateService = this.injector.get(TranslateService);

    const csrfService = this.injector.get(CsrfTokenService); 
    const authHeaders = csrfService.getHeaders(); 

    const selectedLang = localStorage.getItem('selectedLang');
    const acceptLanguage = selectedLang === 'gr' ? 'el' : 'en';

    const isSkipAuth = req.headers.has('X-Skip-Auth') || req.url.includes('refresh-token');

    const headers: { [key: string]: string } = {
      'Accept-Language': acceptLanguage
    };

    const isBackendRequest = this.isBackendRequest(req.url);

    const sessionId = this.authService.getSessionId();
    if (isBackendRequest && sessionId) {
      headers[AUTH_SESSION_HEADER] = sessionId;
    }

    if (isBackendRequest && !isSkipAuth && authHeaders?.get('Authorization') && authHeaders.get('Authorization') !== 'Bearer ') {
      headers['Authorization'] = authHeaders.get('Authorization') || '';
      headers['X-CSRF-TOKEN'] = authHeaders.get('X-CSRF-TOKEN') || '';
    }

    let clonedRequest = req.clone({
      setHeaders: headers,
      withCredentials: isBackendRequest
    });

    if (clonedRequest.headers.has('X-Skip-Auth')) {
      clonedRequest = clonedRequest.clone({
        headers: clonedRequest.headers.delete('X-Skip-Auth')
      });
    }

    if (clonedRequest.headers.has('X-Skip-Refresh')) {
      clonedRequest = clonedRequest.clone({
        headers: clonedRequest.headers.delete('X-Skip-Refresh')
      });
    }

    return next.handle(clonedRequest);
  }

  private isBackendRequest(url: string): boolean {
    const apiBaseUrl = getApiBaseUrl();
    if (apiBaseUrl) {
      try {
        const base = new URL(apiBaseUrl);
        const target = new URL(url, typeof window !== 'undefined' ? window.location.origin : base.origin);
        const basePath = base.pathname.replace(/\/$/, '');
        return target.origin === base.origin &&
          (!basePath || target.pathname === basePath || target.pathname.startsWith(basePath + '/'));
      } catch {
        return false;
      }
    }

    return url.startsWith('/gateway') || url.startsWith('/api');
  }
}
